export default __webpack_public_path__ + "static/media/lista2.1c5f26d0.png";